import React, { Component } from 'react';
// import Wrp from '../../hoc/Wrp/Wrp';
import KanbanItem from './KanbanItem';
import DVpreview from './DVpreview';
import ProfileCard from './ProfileCard';
import DVtabsLoader from './DVtabsLoader';
import TimelineSkeleton from './TimelineSkeleton';
import NestedList from './NestedList';
import EmailListing from './EmailListing';
import TableRow from './TableRow';
import TableColumn from './TableColumn';

class Skeleton extends Component {
	render() {
		switch(this.props.type) {
			case 'kanbanItem' :
				return  <KanbanItem  {...this.props}/>;
			case 'DVpreview' :
				return  <DVpreview  {...this.props}/>;	
			case 'ProfileCard' :
				return  <ProfileCard  {...this.props}/>;		
			case 'DVtabsLoader' :
				return  <DVtabsLoader  {...this.props}/>;
			case 'Timeline' :
				return  <TimelineSkeleton  {...this.props} />;	
			case 'NestedList':
				return <NestedList  {...this.props}/>;
			case 'EmailListing':
				return <EmailListing  {...this.props} />;
			case 'TableRow':
				return <TableRow {...this.props}/>;	
			case 'TableColumn':
					return <TableColumn {...this.props}/>;				
			default :
			    return <rect x="25" y="105" rx="5" ry="5" width="220" height="10" />;				
		}
	}
}

export default Skeleton;